import { resize } from "utils"

export const takeScreenshot = (width: number, height: number, gl: WebGL2RenderingContext, program: WebGLProgram) => {
  const canvas = <HTMLCanvasElement>gl.canvas
  const oldWidth = canvas.width / devicePixelRatio
  const oldHeight = canvas.height / devicePixelRatio

  resize(width, height, gl, program)

  gl.drawArrays(gl.TRIANGLES, 0, 6)

  // save
  const filename: string = defaultFileName()
  canvas.toBlob((blob) => {
    saveBlob()(blob, filename)
  })

  resize(oldWidth, oldHeight, gl, program)
  gl.uniform1i(gl.getUniformLocation(program, "u_print"), 0)
  gl.drawArrays(gl.TRIANGLES, 0, 6)
}

const saveBlob = () => {
  const a = document.createElement("a")
  document.body.appendChild(a)
  a.style.display = "none"
  return function saveData(blob: Blob | null, fileName: string) {
    if (blob == null) return
    const url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = fileName
    a.click()
  }
}

const defaultFileName = () => {
  const str = `Symmetry-Camille-Roux.png`
  return str.replace(/\//g, "-").replace(/:/g, ".")
}
